import { useEffect, useRef } from "react";

export function useEffectOnce(callback: Function, shouldRunNow: boolean): void {
  const hasRunOnce = useRef(false);
  useEffect(() => {
    if (shouldRunNow && !hasRunOnce.current) {
      callback();
      hasRunOnce.current = true;
    }
  }, [shouldRunNow]);
}
